import ArrowRightIcon from '../svg/ArrowRightIcon';

const iconText = {
  ACH: 'ACH',
  WIRE: 'WIRE',
  SPEI: 'SPEI',
  SEPA: 'SEPA',
  PIX: 'PIX',
  CNAPS: 'CNAPS',
  'BIC/SWIFT': 'BIC SWIFT',
  'Código de banco': 'Código banco',
};

export default function PaymentRoute({ route, description, onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-full px-6 py-2 space-x-1 cursor-pointer bg-[#FCFCFC99] border border-[#CDD9F0] rounded-[10px] flex items-center justify-between"
    >
      <div className="min-w-10.5 w-10.5 h-10.5 bg-gradient-to-r from-[#092F7B] to-[#1056E1] rounded-full flex items-center justify-center">
        <div className="text-[8px] text-white font-semibold">
          {iconText[route].split(' ').length > 1 ? (
            <>
              <p>{iconText[route].split(' ')[0]}</p>
              <p>{iconText[route].split(' ')[1]}</p>
            </>
          ) : (
            iconText[route]
          )}
        </div>
      </div>
      <div>
        <p className="text-sm text-[#414651] font-medium leading-[22px]">
          {route}
        </p>
        <p className="text-xs text-[#535862] font-normal leading-[22px]">
          {description}
        </p>
      </div>
      <ArrowRightIcon />
    </button>
  );
}
